import { Link } from '@lt/components';
import type { FC } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  getTourOperatorLinkById,
  getTourOperatorNameById,
} from '../../CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { getIsLoggedUser } from '../../store/selectors/user';

interface OperatorDetailsProps {
  className?: string;
  operatorName: string;
  bookingUrl: string;
  isLoggedUser?: boolean;
}

const OperatorDetails: FC<OperatorDetailsProps> = ({
  className,
  operatorName,
  bookingUrl,
  isLoggedUser,
}) => (
  <BookingLink
    as={isLoggedUser ? Link : 'span'}
    href={bookingUrl}
    className={className}
  >
    Тур от {operatorName}
  </BookingLink>
);

const BookingLink = styled.span`
  display: block;
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
  color: #17181a;
  margin-top: 4px;
`;

const mapStateToProps = (state, props: { tourId: string }) => ({
  operatorName: getTourOperatorNameById(state, props.tourId),
  bookingUrl: getTourOperatorLinkById(state, props.tourId),
  isLoggedUser: getIsLoggedUser(state),
});

export default connect(mapStateToProps)(OperatorDetails);
